import { render, staticRenderFns } from "./Text.vue?vue&type=template&id=99fdeb7a&scoped=true"
import script from "./Text.vue?vue&type=script&lang=js"
export * from "./Text.vue?vue&type=script&lang=js"
import style0 from "./Text.vue?vue&type=style&index=0&id=99fdeb7a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99fdeb7a",
  null
  
)

export default component.exports